import React from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
import { Form, Button } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { map, times } from 'lodash';
import styled from 'styled-components';
import moment from 'moment';
import { HHAlert } from '../common/util';
import { ALERT_TYPE } from '../common/constant';
import { HHInput, HHRadioGroup, HHDatePicker, HHSingleSelect } from './fields';
import { signIn } from '../actions';

const formikEnhancer = withFormik({
  validationSchema: ({ translate }) => Yup.object().shape({
    couponCode: Yup
      .string()
      .max(64, translate('form.error.string.max'))
      .required(translate('form.error.mixed.required')),
    prize: Yup.string(),
    discountType: Yup
      .string()
      .required(translate('form.error.mixed.required')),
    discountAmount: Yup
      .number()
      .required(translate('form.error.mixed.required')),
    expireDate: Yup.date().required(translate('form.error.mixed.required')),
    quantity: Yup
      .number()
      .required(translate('form.error.mixed.required'))
  }),
  validate: (values, { cmsEventTickets }) => {
    const errors = {};
    const { discountType, discountAmount } = values;
    if ((discountType === 'percentage' && discountAmount > 1) || (discountType === 'cash' && discountAmount < 1)) {
      errors.discountAmount = 'Required';
    }

    const freeTickets = cmsEventTickets.filter(ticket =>
      (discountType === 'percentage' && (ticket.price * discountAmount < 1)) ||
      (discountType === 'cash' && ((ticket.price - discountAmount) < 1))
    );
    if (freeTickets.length > 0) {
      HHAlert({ id: 'alert.warning.couponAmountLimit' }, ALERT_TYPE.WARNING);
    }
    return errors;
  },
  mapPropsToValues: (props) => (props.initialValues),
  handleSubmit: (values, { props }) => {
    props.handleSubmit({ ...values, discountAmount: parseFloat(values.discountAmount).toFixed(2) });
  }
});

const CouponForm = (props) => {
  const {
    handleCancel,
    handleSubmit,
    isSubmitting,
    isEditing,
    translate,
    timezone,
    activeLanguage,
    values
  } = props;

  const { discountType } = values;
  const amountOptions = discountType === 'percentage' ? map(times(10, x => x + 1), y => ({ value: (10 - y) / 10, label: `${y * 10}% Off` })) : map(times(100, x => x + 1), y => ({ value: y, label: y }));

  return (
    <Form
      onSubmit={handleSubmit}
      className='cms-awards_form cms-awards_table_item_description'
    >
      <div className='cms-awards_form_formGroup'>
        <Form.Field>
          <label htmlFor='couponCode'>{translate('coupon.required')}</label>
          <Field
            name='couponCode'
            component={HHInput}
            otherProps={{
              type: 'text',
              id: 'couponCode',
              maxLength: 64
            }}
          />
        </Form.Field>

        <Form.Field>
          <label htmlFor='discountType'>{translate('discountType')}</label>
          <StyledGroupCheckbox>
            <Field
              name='discountType'
              component={HHRadioGroup}
              otherProps={{
                items: [{ value: 'percentage', label: translate('eventAdmin.coupon.type.percentage') }, { value: 'cash', label: translate('eventAdmin.coupon.type.cash') }],
                radioGroupName: 'discountType'
              }}
            />
          </StyledGroupCheckbox>

        </Form.Field>
        <Form.Field>
          <label htmlFor='expireDate'>{translate('end.date.and.time')}</label>
          <Field
            name='expireDate'
            component={HHDatePicker}
            otherProps={{
              id: 'expireDate',
              locale: activeLanguage.code,
              timezone,
              minDate: moment(),
              placeholderText: translate('select end date')
            }}
          />
        </Form.Field>
      </div>
      <div className='cms-awards_form_limit'>
        <Form.Field>
          <label htmlFor='quantity'>{translate('quantity')} *</label>
          <Field
            name='quantity'
            component={HHSingleSelect}
            otherProps={{
              id: 'quantity',
              simpleValue: true,
              creatable: true,
              options: map(times(100, x => x + 1), y => ({ value: y, label: y })),
              placeholder: '0'
            }}
          />
        </Form.Field>
        <Form.Field>
          <label htmlFor='discountAmount'>{translate('discountAmount')} *</label>
          <Field
            name='discountAmount'
            component={HHSingleSelect}
            otherProps={{
              id: 'discountAmount',
              options: amountOptions,
              placeholder: '0',
              simpleValue: true,
              creatable: true
            }}
          />
        </Form.Field>
      </div>

      <div className='cms-awards_form_btnGroup'>
        {handleCancel && (
          <Button
            basic
            type='button'
            onClick={handleCancel}
            className='cms-awards_form_btnGroup_btn-cancel'
          >
            {translate('cancel')}
          </Button>
        )}
        <Button
          loading={isSubmitting}
          primary
          disabled={isSubmitting}
          className='cms-awards_form_btnGroup_btn-submit'
          type='submit'
        >
          {isEditing ? translate('save') : translate('create')}
        </Button>
      </div>
    </Form>
  );
};

const StyledGroupCheckbox = styled.div`
  display: flex;
  .checkbox {
    margin-right: 2rem;
  }
`;

export default compose(
  withLocalize,
  connect(({ cmsEventTickets }) => ({ cmsEventTickets }), { signIn }),
  formikEnhancer
)(CouponForm);



// WEBPACK FOOTER //
// ./src/components/forms/couponForm.js